module.exports = __webpack_public_path__ + "static/media/pdfFile.a3d7c23a.png";